module.exports = __webpack_public_path__ + "static/media/vegas-nights.5c3a47d1.gif";